import { useAuthorization } from 'components/Authorization';

const useAccid = () => {
  return useAuthorization<Oversea.Token.Payload>()?.payload?.accid;
};

export default useAccid;
